import { render, staticRenderFns } from "./FilesListFooter.vue?vue&type=template&id=2e19f455&scoped=true&"
import script from "./FilesListFooter.vue?vue&type=script&lang=ts&"
export * from "./FilesListFooter.vue?vue&type=script&lang=ts&"
import style0 from "./FilesListFooter.vue?vue&type=style&index=0&id=2e19f455&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e19f455",
  null
  
)

export default component.exports